import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { ListboxModule } from 'primeng/listbox';
import { TableModule } from 'primeng/table';
import { FormgenModule } from '../../libraries/formgen/formgen.module';
import { LibrariesModule } from '../../libraries/libraries.module';
import { SharedModule } from '../../libraries/shared.module';
import { NewsCreateComponent } from './create/news-categories-create.component';
import { NewsFormComponent } from './form/news-categories-form.component';
import { NewsListComponent } from './list/news-categories-list.component';
import { NewsCategoriesRestService } from './news-categories-rest.service';
import { NewsCategoriesRoutingModule } from './news-categories-routing.module';
import { NewsCategoriesUpdateComponent } from './update/news-categories-update.component';

export const PROVIDERS = [NewsCategoriesRestService];

@NgModule({
  imports: [
    NewsCategoriesRoutingModule,
    BsDropdownModule,
    CommonModule,
    FlexLayoutModule,
    FormgenModule,
    FormsModule,
    ListboxModule,
    LibrariesModule,
    PaginationModule,
    ReactiveFormsModule,
    RouterModule,
    SharedModule,
    TableModule,
    TranslateModule
  ],
  declarations: [
    NewsCreateComponent,
    NewsFormComponent,
    NewsListComponent,
    NewsCategoriesUpdateComponent
  ]
})
export class NewsCategoriesModule {}
